module.exports = __webpack_public_path__ + "static/img/1huifengHKCard.f4f2cf8f.png";